import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VoucherEmailModalComponent } from '../../../order/voucher/voucher-email-modal/voucher-email-modal.component';
import { PaymentLinkEmailModalComponent } from '../../modal/payment-link-email-modal/payment-link-email-modal.component';

@Component({
  selector: 'payment-link-email-send',
  templateUrl: './payment-link-email-send.component.html',
  styleUrls: ['./payment-link-email-send.component.scss']
})
export class PaymentLinkEmailSendComponent implements OnInit {

  @Input("email") email              = null;
  @Input("id") id                    = null;
  @Input("paymentId") paymentId      = null;
  @Input("paymentLink") paymentLink  = false;

  constructor(
    private dialog: MatDialog
  ){}
  /***
   * 
   * Open send email
   * 
   */
  open(){

    this.dialog.open(PaymentLinkEmailModalComponent,{
      width: "600px",
      data: {
        email: this.email,
        id: this.id,
        paymentId: this.paymentId,
        paymentLink: this.paymentLink
      }
    });

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
